/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Built_For_BodyInputs */

const en_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same principle applies whether you are picking up a club for the first time or preparing for tournament season.`)
};

const es_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mismo principio aplica ya sea que tomes un palo por primera vez o te prepares para la temporada de torneos.`)
};

const de_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das gleiche Prinzip gilt, ob Sie zum ersten Mal einen Schläger in die Hand nehmen oder sich auf die Turniersaison vorbereiten.`)
};

const zh_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无论你是第一次拿起球杆，还是在为比赛季做准备，这个原则都同样适用。`)
};

const ar_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ينطبق المبدأ نفسه سواء كنت تمسك المضرب لأول مرة أو تستعد لموسم البطولات.`)
};

const fr_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le même principe s’applique, que vous preniez un club pour la première fois ou que vous prépariez la saison de tournois.`)
};

const vi_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cùng một nguyên tắc áp dụng dù bạn mới cầm gậy lần đầu hay đang chuẩn bị mùa giải.`)
};

const sw_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanuni hiyo hiyo inatumika iwe unashika fimbo ya gofu kwa mara ya kwanza au unajiandaa kwa msimu wa mashindano.`)
};

const th_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หลักการเดียวกันนี้ใช้ได้ ไม่ว่าคุณจะเพิ่งจับไม้กอล์ฟเป็นครั้งแรก หรือกำลังเตรียมตัวสำหรับฤดูกาลทัวร์นาเมนต์`)
};

const bs_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isti princip važi bilo da prvi put uzimate palicu ili se spremate za turnirsku sezonu.`)
};

const ja_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初めてクラブを握る方にも、トーナメントシーズンに向けて準備している方にも、同じ原則が当てはまります。`)
};

const ko_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`처음 클럽을 잡는 분이든 토너먼트 시즌을 준비하는 분이든, 같은 원칙이 적용됩니다.`)
};

const pt_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mesmo princípio vale tanto para quem pega um taco pela primeira vez quanto para quem está se preparando para a temporada de torneios.`)
};

const it_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo stesso principio vale sia che tu prenda in mano un bastone per la prima volta, sia che ti stia preparando alla stagione dei tornei.`)
};

const sv_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samma princip gäller oavsett om du tar i en golfklubba för första gången eller förbereder dig för tävlingssäsongen.`)
};

const nl_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hetzelfde principe geldt of je nu voor het eerst een golfclub oppakt of je voorbereidt op het toernooiseizoen.`)
};

const da_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det samme princip gælder, uanset om du tager en kølle i hånden for første gang eller forbereder dig på turneringssæsonen.`)
};

const nb_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det samme prinsippet gjelder enten du tar i en golfkølle for første gang eller forbereder deg til turneringssesongen.`)
};

const fi_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sama periaate pätee, olitpa tarttumassa mailaan ensimmäistä kertaa tai valmistautumassa kilpailukauteen.`)
};

const pl_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta sama zasada obowiązuje niezależnie od tego, czy po raz pierwszy bierzesz do ręki kij golfowy, czy przygotowujesz się do sezonu turniejowego.`)
};

const ru_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот принцип действует одинаково, берёте ли вы клюшку в руки впервые или готовитесь к турнирному сезону.`)
};

const tr_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aynı ilke, sopayı ilk kez elinize alıyor olsanız da turnuva sezonuna hazırlanıyor olsanız da geçerlidir.`)
};

const hi_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यही सिद्धांत लागू होता है, चाहे आप पहली बार गोल्फ़ क्लब हाथ में ले रहे हों या टूर्नामेंट सीज़न की तैयारी कर रहे हों।`)
};

const id_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prinsip yang sama berlaku, entah Anda baru pertama kali memegang stik golf atau sedang bersiap menghadapi musim turnamen.`)
};

const ms_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prinsip yang sama terpakai sama ada anda baru pertama kali memegang kayu golf atau sedang bersiap sedia untuk musim kejohanan.`)
};

const cs_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stejný princip platí, ať poprvé berete hůl do ruky, nebo se připravujete na turnajovou sezónu.`)
};

const el_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η ίδια αρχή ισχύει είτε πιάνετε μπαστούνι του γκολφ για πρώτη φορά είτε προετοιμάζεστε για τη σεζόν των τουρνουά.`)
};

const he_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אותו עיקרון חל בין אם אתם מחזיקים מחבט גולף בפעם הראשונה ובין אם אתם מתכוננים לעונת הטורנירים.`)
};

const af_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieselfde beginsel geld of jy vir die eerste keer 'n knuppel optel of vir die toernooiseisoen voorberei.`)
};

const hu_injury_built_for_body = /** @type {(inputs: Injury_Built_For_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyanez az elv érvényes, akár most fogsz először ütőt a kezedbe, akár a versenyszezonra készülsz.`)
};

/**
* | output |
* | --- |
* | "The same principle applies whether you are picking up a club for the first time or preparing for tournament season." |
*
* @param {Injury_Built_For_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_built_for_body = /** @type {((inputs?: Injury_Built_For_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Built_For_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_built_for_body(inputs)
	if (locale === "de") return de_injury_built_for_body(inputs)
	if (locale === "zh") return zh_injury_built_for_body(inputs)
	if (locale === "ar") return ar_injury_built_for_body(inputs)
	if (locale === "fr") return fr_injury_built_for_body(inputs)
	if (locale === "vi") return vi_injury_built_for_body(inputs)
	if (locale === "sw") return sw_injury_built_for_body(inputs)
	if (locale === "th") return th_injury_built_for_body(inputs)
	if (locale === "bs") return bs_injury_built_for_body(inputs)
	if (locale === "ja") return ja_injury_built_for_body(inputs)
	if (locale === "ko") return ko_injury_built_for_body(inputs)
	if (locale === "pt") return pt_injury_built_for_body(inputs)
	if (locale === "it") return it_injury_built_for_body(inputs)
	if (locale === "sv") return sv_injury_built_for_body(inputs)
	if (locale === "nl") return nl_injury_built_for_body(inputs)
	if (locale === "da") return da_injury_built_for_body(inputs)
	if (locale === "nb") return nb_injury_built_for_body(inputs)
	if (locale === "fi") return fi_injury_built_for_body(inputs)
	if (locale === "pl") return pl_injury_built_for_body(inputs)
	if (locale === "ru") return ru_injury_built_for_body(inputs)
	if (locale === "tr") return tr_injury_built_for_body(inputs)
	if (locale === "hi") return hi_injury_built_for_body(inputs)
	if (locale === "id") return id_injury_built_for_body(inputs)
	if (locale === "ms") return ms_injury_built_for_body(inputs)
	if (locale === "cs") return cs_injury_built_for_body(inputs)
	if (locale === "el") return el_injury_built_for_body(inputs)
	if (locale === "he") return he_injury_built_for_body(inputs)
	if (locale === "af") return af_injury_built_for_body(inputs)
	if (locale === "hu") return hu_injury_built_for_body(inputs)
	return en_injury_built_for_body(inputs)
});